import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ADMIN_PAGES, MANAGER_PAGES, STAFF_PAGES } from "../constants";

function Sidebar({ user }) {
  const navigate = useNavigate();
  const { adminSection } = useParams();
  const section = adminSection || "customer";

  const doClick = (link) => {
    navigate(link);
  };

  const allowedPages = useMemo(() => {
    if (user.role === "admin") {
      return ADMIN_PAGES;
    } else if (user.role === "manager") {
      return MANAGER_PAGES;
    } else if (user.role === "staff") {
      return STAFF_PAGES;
    } else {
      return [];
    }
  }, [user]);

  const menus = useMemo(
    () =>
      allowedPages.map((menu) => {
        const activeClassName = section === menu.link ? "bg-slate-200" : "";
        return (
          <li
            key={menu.label}
            className={`hover:bg-slate-200 px-10 py-2 font-semibold cursor-pointer ${activeClassName}`}
            onClick={() => doClick(`/__admin/${menu.link}`)}
          >
            {menu.label}
          </li>
        );
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [adminSection, user],
  );

  return (
    <div className="sidebar py-2 min-h-screen bg-slate-300 min-w-52">
      <ul>{menus}</ul>
    </div>
  );
}

export default Sidebar;
